import Model from '../Apis/Settings'
import Controller from './Controller'
import { serialize } from 'object-to-formdata';

export default class SettingController extends Controller {
    constructor() {
        super(new Model())
    }
    async time(params) {
        const data = await this.model.time(params)
        return data
    }
    async addNewRoutes(data) {
        const newData = serialize(
            data,
            this.options,
        )
        
        console.log("c", newData,this.options,this.headers);
        const res = await this.model.addNewRoutes(newData, this.headers);
        this.Poup(res);
    }
}